/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Last_Event_TimecodeInputs */

const en_last_event_timecode = /** @type {(inputs: Last_Event_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last event timecode`)
};

const fr_last_event_timecode = /** @type {(inputs: Last_Event_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timecode du dernier événement`)
};

const de_last_event_timecode = /** @type {(inputs: Last_Event_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitcode des letzten Ereignisses`)
};

const it_last_event_timecode = /** @type {(inputs: Last_Event_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codice temporale dell'ultimo evento`)
};

const ru_last_event_timecode = /** @type {(inputs: Last_Event_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последний временной код события`)
};

const es_last_event_timecode = /** @type {(inputs: Last_Event_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de tiempo del último evento`)
};

const zh_cn2_last_event_timecode = /** @type {(inputs: Last_Event_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上次事件时间码`)
};

const ja_last_event_timecode = /** @type {(inputs: Last_Event_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最後のイベントのタイムコード`)
};

const hi_last_event_timecode = /** @type {(inputs: Last_Event_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंतिम घटना का समय कोड`)
};

const pt_pt2_last_event_timecode = /** @type {(inputs: Last_Event_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de tempo do último evento`)
};

/**
* | output |
* | --- |
* | "Last event timecode" |
*
* @param {Last_Event_TimecodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const last_event_timecode = /** @type {((inputs?: Last_Event_TimecodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Last_Event_TimecodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_last_event_timecode(inputs)
	if (locale === "de") return de_last_event_timecode(inputs)
	if (locale === "it") return it_last_event_timecode(inputs)
	if (locale === "ru") return ru_last_event_timecode(inputs)
	if (locale === "es") return es_last_event_timecode(inputs)
	if (locale === "zh-CN") return zh_cn2_last_event_timecode(inputs)
	if (locale === "ja") return ja_last_event_timecode(inputs)
	if (locale === "hi") return hi_last_event_timecode(inputs)
	if (locale === "pt-PT") return pt_pt2_last_event_timecode(inputs)
	return en_last_event_timecode(inputs)
});